// Alamat server (host:port, tanpa http://) dari REACT_APP_URL.
// Bila REACT_APP_URL menunjuk localhost (pengembangan) tetapi web dibuka dari alamat lain, mis. HP di
// jaringan yang sama (aplikasi admin Flutter), host halaman ini yang dipakai dengan port server yang sama.
// Production (REACT_APP_URL = domain) tidak terpengaruh.
const LOKAL = ['localhost', '127.0.0.1'];

export const apiHost = () => {
  let alamat = (process.env.REACT_APP_URL || '').replace(/^https?:\/\/+/, '');
  const [host, port] = alamat.split(':');
  const halaman = window.location.hostname;
  if (LOKAL.includes(host) && halaman && !LOKAL.includes(halaman)) {
    alamat = port ? `${halaman}:${port}` : halaman;
  }
  return alamat;
};
